var   $          = global.jQuery
     ,ko         = require('knockout')
     ,core       = require('CoreModule')
     ,events     = core.Events
     ,helpers    = core.Helpers
     ,md5        = require("md5")



var SplitViewModel = function (init) {

    var self = this
       ,update = _.noop
       ,setTimeoutUpdate = function () { update(), setTimeout(update, 100), setTimeout(update, 300) }// set to resize panels

    var storageProvider = ko.storage.createStorageProvider('split', 'guest', 7 * 24 * 60 * 60000);

    self.helpers     = helpers;
    self.initialized = ko.observable(true);
    self.busy        = ko.observable();
  

    self.leftHandViewComponent = ko.observable();
    self.leftHandViewParams    = ko.observable();

    self.rightHandViewComponent = ko.observable();
    self.rightHandViewParams    = ko.observable();

    self.GalleryKey = ko.observable(init.GalleryKey);

    self.ContentManagementEnabled = ko.observable(init.GalleryDetails2.IsContentManagementEnabled);
    var ContentManagerTokenHash   = init.GalleryDetails2.ContentManagerTokenHash;
    self.ContentManagementActive  = ko.observable();
    

    self.leftPanelVisible = ko.observable(true);
    self.leftPanelVisible.subscribe(function () {    
         events.emitter.emit(events.layout_change)
    } );


    self.toggleFilters = function () {
        self.leftPanelVisible(!self.leftPanelVisible());        
    }

    self.collapseLeftPane = function(){
        self.leftPanelVisible(false);
    }

    self.expandLeftPane = function(){
        self.leftPanelVisible(true);
    }


    _.assign(diagnostics, { collapseLeftPane            : self.collapseLeftPane
                            , expandLeftPane            : self.expandLeftPane      });

    var resizeHandler = helpers.makeHorizontalDistribute([$('#activityBar'), $('#splitLeft')], $('#splitRight') );                            

    self.leftPaneNavigatorCSS = ko.pureComputed(function () {
        return 'col-lg-1 navigator'; // self.leftPanelVisible() ? 'col-lg-1' : 'hidden';
    });

    self.leftPaneCSS = ko.pureComputed(function () {
        return self.leftPanelVisible() ? 'leftContainer' : 'hidden'; // col-lg-3';
    });

    self.rightPaneCSS = ko.pureComputed(function () {
        return 'rightContainer'; // self.leftPanelVisible() ? 'col-lg-9' : 'col-lg-11';
    });

    events.emitter.on(events.resize, resizeHandler);

    events.emitter.on(events.gallery_view_option_change, function (viewOption, viewOptions) {
        console.log('view changed', viewOption, viewOptions)
        switch (viewOption) {
            case viewOptions.QueryResults  : self.expandLeftPane();   break;
            case viewOptions.SelectedItems : self.collapseLeftPane(); break;
        }
    });


    // todo:restrict transition to valid next states/views
    var setLeftHandViewComponent = function (viewName, params) {
        
        var componentName = viewName.toLowerCase() + '-view', footer = _.includes(['Call', 'Grid'], viewName);
        console.error('setting view', componentName);
        self.leftHandViewComponent(componentName).leftHandViewParams(params).leftPanelVisible(true);
        setTimeoutUpdate();
        return self;
    }

    var setRightHandViewComponent = function (viewName, params) {
        
        var componentName = viewName.toLowerCase() + '-view', footer = _.includes(['Call', 'Grid'], viewName);
        console.error('setting view', componentName);
        self.rightHandViewComponent(componentName).rightHandViewParams(params);
        setTimeoutUpdate();
        return self;
    }

    setLeftHandViewComponent( init.Context.LeftHandView , _.assign(init, {option:'none'}));
    setRightHandViewComponent(init.Context.RightHandView, _.assign(init, {option:'none'}));

    self.modalVisible   = ko.observable();
    self.clickShowModal = function () { self.modalVisible(true) }
    self.resetConfirm = function name() {

          ko.storage.clear('app'    , 'guest')
       && ko.storage.clear('filters', 'guest')
       && diagnostics.deleteDB().then(helpers.reloadPage)
       
    }


    self.modalVisible2  = ko.observable();
    self.authorizeMode = function () {
        console.log('auth mode');
        self.modalVisible2(true);
    }
    
    self.AuthorizationKeyInput = ko.observable().extend(storageProvider);

    var trimmedToken;

    self.checkAuthorizationKey = function () {
        
        trimmedToken = _.trim(self.AuthorizationKeyInput());

        var value = _.toUpper(md5(trimmedToken));
 
        if(value === ContentManagerTokenHash){

            self.emitTokenCode().ContentManagementActive(true).setAuthorView().modalVisible2(false);
        }        
    }
    
    self.clearAuthorizationKey = function () {
        
        self.AuthorizationKeyInput('').ContentManagementActive(false).setPublicView();
    }
    
    self.PublicViewMode = ko.observable(true);
    self.AuthorViewMode = ko.observable(false);
    self.setPublicView  = function () { self.PublicViewMode(true).AuthorViewMode(false).emitViewMode(); return self }
    self.setAuthorView  = function () { self.PublicViewMode(false).AuthorViewMode(true).emitViewMode(); return self }
    self.emitViewMode   = function () { events.emitter.emit(events.view_mode_change, self.AuthorViewMode() ? 'Author' : 'Public') }  
    self.emitTokenCode  = function () { events.emitter.emit(events.manager_code_set, trimmedToken);     return self }

    var autorun = (function () {
        console.error('SplitViewModel', self, init);
        setTimeout(self.checkAuthorizationKey,100);
    })();

    SplitViewModel.prototype.dispose = function () {
        console.error("Disposing SplitViewModel....");
        events.emitter.removeListener(events.resize, resizeHandler);
        console.error("SplitViewModel Disposed....");
    }
}



module.exports = {
     viewModel: SplitViewModel
    ,template : require('SplitView.html')
    ,title    : 'Split View'

};